import { render, staticRenderFns } from "./PermissionMap.vue?vue&type=template&id=6f22b2c2&scoped=true"
import script from "./PermissionMap.vue?vue&type=script&lang=js"
export * from "./PermissionMap.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f22b2c2",
  null
  
)

export default component.exports